'use client';

import ProgressAnime from '@/components/ui/ProgressAnime/ProgressAnime';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useEffect, useRef, useState } from 'react';
import { getBizTeamList } from '../../api/getBizTeamList';
import { TeamListItem } from '../../types';
import BizTeamList from '../BizTeamList/BizTeamList';
import ECommerceSearchNotFound from '../ECommerceSearchNotFound/ECommerceSearchNotFound';

function BizTeamInfiniteList({
  teams,
  pageLimit,
  query,
  requestTime,
}: {
  teams: Array<TeamListItem>;
  pageLimit: number;
  query?: string;
  requestTime: string;
}) {
  const [hasNoMore, setHasNoMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentTeamList, setCurrentTeamList] = useState(teams);
  const targetRef = useRef<HTMLDivElement>(null);

  function handleScroll() {
    const scrollingBottom = targetRef.current?.getBoundingClientRect().bottom;
    if (!scrollingBottom) return;
    if (canFetch(scrollingBottom)) {
      fetchMore();
    }
  }

  const fetchMore = async () => {
    setIsLoading(true);
    window.removeEventListener('scroll', handleScroll); //一回削除
    const lastId = currentTeamList.slice(-1)[0].id;

    const { result: moreTeamList } = await getBizTeamList({
      oemServiceId: Number(process.env.NEXT_PUBLIC_SERVICE_ID),
      requestTime: requestTime,
      paging: 'next',
      limit: pageLimit,
      bizTeamName: query || undefined,
      pagingBizTeamId: lastId,
    });
    if (moreTeamList.length === 0) {
      setHasNoMore(true);
      setIsLoading(false);
      return;
    }
    setCurrentTeamList([...currentTeamList, ...moreTeamList]);
    setIsLoading(false);
    window.addEventListener('scroll', handleScroll); //　終わったら追加
  };

  const canFetch = (scrollingBottom?: number) => {
    if (!scrollingBottom) return false;
    return scrollingBottom < window.innerHeight + 60 && !hasNoMore && !isLoading && teams.length > 0;
  };

  useEffect(() => {
    // スクロール処理
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentTeamList]);

  return (
    <>
      {currentTeamList.length > 0 ? (
        <div ref={targetRef}>
          <BizTeamList teams={currentTeamList}></BizTeamList>
          {isLoading && <ProgressAnime></ProgressAnime>}
        </div>
      ) : (
        <div className={utilsStyles.mtLarge}>
          <ECommerceSearchNotFound></ECommerceSearchNotFound>
        </div>
      )}
    </>
  );
}

export default BizTeamInfiniteList;
